// extracted by mini-css-extract-plugin
module.exports = {"root":"loginLinks_root__6t9xP","link":"loginLinks_link__4KT6p","content":"loginLinks_content__mcEnX","image":"loginLinks_image__BFrJh"};